export const accountTrackingIDs = {
    addAuthorizedCustomer: {
        id: 'dagligbank-add-authorized-customer',
        name: 'add-authorized-customer',
    },
    deleteAuthorizedCustomer: {
        id: 'dagligbank-delete-authorized-customer',
        name: 'delete-authorized-customer',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWNjb3VudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9ndG0vdHJhY2tJRHMvYWNjb3VudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRztJQUM5QixxQkFBcUIsRUFBRTtRQUNuQixFQUFFLEVBQUUsb0NBQW9DO1FBQ3hDLElBQUksRUFBRSx5QkFBeUI7S0FDbEM7SUFDRCx3QkFBd0IsRUFBRTtRQUN0QixFQUFFLEVBQUUsdUNBQXVDO1FBQzNDLElBQUksRUFBRSw0QkFBNEI7S0FDckM7Q0FDSixDQUFDIn0=